import { MessageBox, Space } from '../../../../../components/core-v2'
import { useAppSelector } from '../../../store/hooks'
import { StrategyAttributes } from '../../05-complete/organisms/approval/strategy'

const StrategyDetailsSummary = () => {
  const strategy = useAppSelector(state => state.strategy)
  return (
    <>
      {strategy.isInited && (
        <Space mx={5} my={6}>
          <StrategyAttributes isApproved strategy={strategy.selectedStrategy} />
        </Space>
      )}
      {!strategy.isInited && (
        <Space mx={5} my={6}>
          <MessageBox state="warning" title="A strategy does not yet exist for this trade">
            Please edit the trade and add a strategy
          </MessageBox>
        </Space>
      )}
    </>
  )
}

export default StrategyDetailsSummary
